import { render, staticRenderFns } from "./InvoicesList.vue?vue&type=template&id=9fc383a6&"
import script from "./InvoicesList.vue?vue&type=script&lang=ts&"
export * from "./InvoicesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports